import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { ModalProps } from '@common/components';
import { CustomerViewModel } from '@models/Customer';

import { CustomerPickerComponent, CustomerPickerComponentProperties } from './customer-picker.component';
import { clearCustomer, getCustomer, lookupCustomer } from '../customer-picker.actions';
import { CustomerPickerState } from '../customer-picker.reducer';

export interface CustomerPickerContainerProperties {
  readonly placeholder?: string;

  readonly onPick: (customer?: CustomerViewModel) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: CustomerPickerState,
  ownProps: CustomerPickerContainerProperties
): Partial<CustomerPickerComponentProperties> {
  return {
    customer: state.customer,
    placeholder: ownProps.placeholder
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<CustomerPickerState>,
  ownProps: CustomerPickerContainerProperties
): Partial<CustomerPickerComponentProperties> {
  return {
    clearCustomer: () => dispatch(clearCustomer(ownProps.onPick)),
    loadCustomer: (id: number) => dispatch(getCustomer(id, ownProps.onPick)),
    lookupCustomer: (query: string, id: number) => lookupCustomer(query, id),
    onCustomerSelect: (model: string, value: number) => getCustomer(value, ownProps.onPick),
    toggleModal: ownProps.toggleModal
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CustomerPickerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerPickerComponent);



// WEBPACK FOOTER //
// ./src/customer/_components/customer-picker/_components/customer-picker.container.ts